import { makeAutoObservable } from 'mobx';
import type { ToastConfig } from '@pro-sto/ui';

export class ToastStore {
  private showToastFn: ((config: ToastConfig) => string) | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  initialize(showToast: (config: ToastConfig) => string) {
    this.showToastFn = showToast;
  }

  showError(message: string, title: string = 'Ошибка') {
    if (!this.showToastFn) {
      console.error('ToastStore не инициализирован');
      return;
    }
    this.showToastFn({ type: 'error', title, message, duration: 4000, closable: true });
  }

  showSuccess(message: string, title: string = 'Успешно') {
    if (!this.showToastFn) {
      console.error('ToastStore не инициализирован');
      return;
    }
    this.showToastFn({ type: 'success', title, message, duration: 3000, closable: true });
  }

  showWarning(message: string, title: string = 'Внимание') {
    if (!this.showToastFn) {
      console.error('ToastStore не инициализирован');
      return;
    }
    this.showToastFn({ type: 'warning', title, message, duration: 3500, closable: true });
  }

  showInfo(message: string, title: string = 'Информация') {
    if (!this.showToastFn) {
      console.error('ToastStore не инициализирован');
      return;
    }
    this.showToastFn({ type: 'info', title, message, duration: 3000, closable: true });
  }
}

export const toastStore = new ToastStore();
